module.exports = __webpack_public_path__ + "img/bitgo.78df48e1.png";